<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="signingList"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="tableHeaderColor"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="task === 'add'"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column prop="id" label="編號" width="100"></el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名稱"
        width="120"
      ></el-table-column>
      <el-table-column label="建立簽單時間" width="120">
        <template slot-scope="scope">
          {{
            scope.row.type === '補單'
              ? scope.row.replenishmentAt
              : scope.row.createdAt
          }}
        </template>
      </el-table-column>
      <el-table-column prop="onAddress" label="上車地點"></el-table-column>
      <el-table-column prop="offAddress" label="下車地點"></el-table-column>
      <el-table-column
        prop="employeeNameJobNumber"
        label="乘客名稱"
      ></el-table-column>
      <el-table-column prop="signingNote" label="簽單備註"></el-table-column>
      <el-table-column prop="serviceNote" label="客服備註"></el-table-column>
      <el-table-column prop="actualFare" label="司機金額"></el-table-column>
      <el-table-column prop="serviceFee" label="服務金額"></el-table-column>
      <el-table-column label="總金額">
        <template slot-scope="scope">
          {{ scope.row.serviceFee + scope.row.actualFare }}
        </template>
      </el-table-column>
      <el-table-column v-if="task === 'remove'" label="移除">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            @click="removeSigning(scope.row.id)"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="4" :offset="17">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="searchSigning"
          :page-count="totalPage"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['signingList', 'task', 'totalPage'],
  data() {
    return {
      multipleSelection: [],
    }
  },

  methods: {
    searchSigning(page) {
      this.$emit('searchSigning', page)
    },
    removeSigning(id) {
      this.$emit('removeSigningFromInvoice', id)
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500;'
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    getMultipSelection() {
      let id = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        id.push(this.multipleSelection[i].id)
      }
      return id
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/company/Invoice/AddSigningList.vue